export const ProfileOwner = {
  CurrentUser: 'CurrentUser::ProfileRelation',
  AnotherUsers: 'AnotherUsers::ProfileRelation',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ProfileOwner = (typeof ProfileOwner)[keyof typeof ProfileOwner]
